// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kcujxrtgiparmtdmjocq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtjdWp4cnRnaXBhcm10ZG1qb2NxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMwMTU2MjUsImV4cCI6MjA2ODU5MTYyNX0.NNbtIWqlNzhgC8wyYyowUFxp8lsopYIHNXH3j98Tof8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});